import styled from 'styled-components';

export const ReportDetailSC = styled.div`
  .modal-loading-wrap {
    display: flex;
    justify-content: center;
  }

  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    align-items: flex-start;
    &--infos {
      padding: 10px 0 15px 0;
      width: 100%;
      display: flex;
      div {
        margin-right: 10px;
        p {
          margin-right: 5px;
          font-size: 18px;
        }
      }
    }
    h2,
    p {
      max-width: 100%;
    }
  }

  .documents-wrap {
    padding-top: 20px;
    &--items-wrap {
      padding-top: 10px;
      display: flex;
      flex-flow: row wrap;
      width: 100%;
      .document {
        margin-top: 10px;
        border: none;
        background: none;
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 50%;
        padding-right: 20px;
        &:hover {
          opacity: 0.8;
        }
        &:hover,
        &:active,
        &:focus {
          outline: none;
          box-shadow: none;
        }
        svg {
          min-width: 26px;
          max-width: 26px;
        }
        small {
          word-break: break-all;
          text-align: left;
          padding-left: 10px;
        }
      }
    }
  }

  .greetings {
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 48px;
    /* or 150% */

    text-align: justify;

    color: #6c6c6c;

    &--month {
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 48px;
      /* or 150% */

      text-align: justify;

      color: #f7931e;
    }
  }

  .detail-report {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const ReportColumnSC = styled.div`
  width: 50%;

  .row {
    margin: 24px 6px;
  }

  .title {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: initial;
    /* or 150% */

    text-align: center;

    color: #6c6c6c;

    small {
      font-style: normal;
      font-weight: normal;
      font-size: 22px;
      line-height: 48px;
      /* or 240% */

      text-align: center;

      color: #6c6c6c;
    }
  }

  .info {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: initial;
    /* or 150% */

    text-align: center;

    color: ${({ type }) => (type === 'info' ? '#00AAE4' : '#f89520')};
  }

  .foot {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: initial;
    /* or 170% */

    text-align: center;
    letter-spacing: -0.035em;

    color: #6c6c6c;
  }
`;
